// extracted by mini-css-extract-plugin
export default {"label":"InputLabel_label__Hs0hC","label_focused":"InputLabel_label_focused__+F6OV"};